<template>
  <div class="hrm_input" v-if="showLocationField">
    <label
      class="hrm_input_label block text-sm font-medium text-textLabelLight dark:text-textLabelDark"
      >{{ trans("lang.labels.location") }}
      <span
        v-if="isLocationRequired"
        class="leading-none ml-1 text-lg text-red-600"
        >*</span
      >
    </label>
    <div class="relative mt-2">
      <template v-if="disabledField">
        <span  class="hrm_input_span_field block mt-2 w-full">
          {{ formData?.location?.location_name }}
        </span>
      </template>
      <VueMultiselect
        v-else
        class="hrm-vuemultiselect hrm_input_field"
        v-model="formData.location_id"
        :options="locations"
        @select="onChangeLocation"
        @clear="onClearLocation"
        :placeholder="trans('lang.labels.Select')"
        label="location_name"
        valueProp="id"
        :searchable="true"
      />
    </div>
    <span
      v-if="errorData && errorData?.location_id"
      class="mt-2 text-xs text-red-600 theme-error-message"
      >{{ errorData?.location_id[0] }}</span
    >
  </div>
  <div class="theme-input hrm_input" v-if="showDeparmentField">
    <label
      class="hrm_input_label text-sm font-medium text-gray-800 dark:text-gray-400"
      >{{ trans("lang.labels.main_department") }}
      <span
        v-if="isDeparmentRequired"
        class="leading-none ml-1 text-lg text-red-600"
        >*</span
      >
    </label>
    <div class="relative mt-2">
        <template v-if="disabledField">
        <span  class="hrm_input_span_field block mt-2 w-full">
          {{ formData?.department?.department_name }}
        </span>
      </template>
      <VueMultiselect v-else
        :key="componentKey"
        class="hrm-vuemultiselect"
        v-model="formData.department_id"
        @select="onChangeDepartment"
        @clear="onClearDepartment"
        :options="departments"
        :placeholder="trans('lang.labels.Select')"
        label="department_name"
        valueProp="id"
        :searchable="true"
      />
    </div>
    <span
      v-if="errorData && errorData?.department_id"
      class="mt-2 text-xs text-red-600 theme-error-message"
      >{{ errorData?.department_id[0] }}</span
    >
  </div>
  <div class="theme-input hrm_input" v-if="showDesignationField">
    <label
      class="hrm_input_label text-sm font-medium text-gray-800 dark:text-gray-400"
      >{{ trans("lang.labels.dashboard_designation") }}
      <span
        v-if="isDesignationRequired"
        class="leading-none ml-1 text-lg text-red-600"
        >*</span
      >
    </label>
    <div class="relative mt-2">
         <template v-if="disabledField">
        <span  class="hrm_input_span_field block mt-2 w-full">
          {{ formData?.designation?.name }}
        </span>
      </template>
      <VueMultiselect v-else
        :key="componentKey"
        class="hrm-vuemultiselect"
        v-model="formData.designation_id"
        :options="designations"
        :placeholder="trans('lang.labels.Select')"
        label="name"
        valueProp="id"
        :searchable="true"
        @clear="onClearDesignation"
      />
    </div>
    <span
      v-if="errorData && errorData?.designation_id"
      class="mt-2 text-xs text-red-600 theme-error-message"
      >{{ errorData?.designation_id[0] }}</span
    >
  </div>
</template>
<script setup>
import { onMounted, ref } from "vue";
import VueMultiselect from "@vueform/multiselect";

const props = defineProps({
  showLocationField: { type: Boolean, default: false },
  showDesignationField: { type: Boolean, default: false },
  showDeparmentField: { type: Boolean, default: false },
  isLocationRequired: { type: Boolean, default: false },
  isDesignationRequired: { type: Boolean, default: false },
  isDeparmentRequired: { type: Boolean, default: false },
  formData: { type: Object, required: true },
  errorData: { type: Object, default: () => ({}) },
  employeeFormData: { type: Object, required: true },
  disabledField: { type: Boolean, default: false },
});
const globalData = ref({});

const locations = ref([]);
const departments = ref([]);
const designations = ref([]);
const queryData = ref({
  perPage: "all",
  status: 1,
});
const componentKey = ref(1);

const onChangeLocation = async () => {
  await getDepartments(props.formData.location_id);
};

const onClearLocation = () => {
  props.formData.location_id = null;
  props.formData.designation_id = null;
  props.formData.department_id = null;
  departments.value = [];
  designations.value = [];
  componentKey.value += 1;
};

const onChangeDepartment = () => {
    props.formData.designation_id = null;
  getDesignations(props.formData.department_id);
};

const onClearDepartment = () => {
  props.formData.department_id = null;
  props.formData.designation_id = null;
  designations.value = [];
  componentKey.value += 1;
};

const onClearDesignation = () => {
  props.formData.designation_id = null;
};

const getLocations = async () => {
  try {
    const response = await axios.get(route("hrm.office-locations.index"), {
      params: queryData.value,
    });
    const locData = response.data.data;
    if (locData && locData.length == 0) {
      locations.value = props.employeeFormData.locationData;
    } else {
      locations.value = response.data.data;
    }
  } catch (error) {
    console.error("Error fetching locations:", error);
  }
};

const getDepartments = async (locationId) => {
  queryData.value.locationId = locationId;
  try {
    const response = await axios.get(route("hrm.departments.index"), {
      params: queryData.value,
    });
    const depData = response.data.data;
    if (depData && depData.length == 0 && globalData.value?.locationId === locationId) {
      departments.value = props.employeeFormData.departmentData;
    } else {
      departments.value = response.data.data;
    }
  } catch (error) {
    console.error("Error fetching departments:", error);
  }
};

const getDesignations = (departmentId) => {
  queryData.value.departmentId = departmentId;
  axios
    .get(route("hrm.designations.index"), {
      params: queryData.value,
    })
    .then((response) => {
      const desData = response.data.data;
      if (desData && desData.length == 0 && globalData.value?.departmentId === departmentId) {
        designations.value = props.employeeFormData.designationData;
      } else {
        designations.value = response.data.data;
      }
      globalData.value.departmentId = departmentId;
    })
    .catch((error) => {})
    .finally(() => {});
};

onMounted(async () => {
  await getLocations();
  await getDepartments(props.formData.location_id);
  getDesignations(props.formData.department_id);
});
</script>